import { createRoot } from "react-dom/client";
import dayjs from "dayjs";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import IsToday from "dayjs/plugin/isToday";
import IsoWeek from "dayjs/plugin/isoWeek";
import Utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { App } from "./App";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "video-react/dist/video-react.css";
import "./css/index.scss";
import ThemeProvider from "./theme/themeProvider";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "rc-slider/assets/index.css";
import { mixpanel } from "./mixpanel";

dayjs.extend(LocalizedFormat);
dayjs.extend(IsToday);
dayjs.extend(IsoWeek);
dayjs.extend(Utc);
dayjs.extend(timezone);

mixpanel.init(import.meta.env.VITE_APP_MIXPANEL_TOKEN || "");

declare module "valtio" {
    function useSnapshot<T extends object>(p: T): T;
}

const container = document.getElementById("root");
if (container) {
    const root = createRoot(container);
    root.render(
        <ThemeProvider>
            <App />
        </ThemeProvider>
    );
} else {
    throw new Error("Root element not found");
}
